package amazon.lastmile.inject

import app.nestbridge.feature.common.presentation.DocumentViewerPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DocumentViewerPresenterFactory::class)
public interface AppNestbridgeFeatureCommonPresentationDocumentViewerPresenterFactory {
  @Provides
  @IntoSet
  public fun provideDocumentViewerPresenterFactoryFactoryMultibinding(documentViewerPresenterFactory: DocumentViewerPresenterFactory): Presenter.Factory = documentViewerPresenterFactory
}
